import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import NavMenu from "../navigation/NavMenu";
import LoginHeader from "../login/LoginHeader";
import translate from "react-i18next/dist/commonjs/translate";

/* eslint-disabled */
import logo from "../logo/cygate_logo.svg"; // eslint-disable-line import/namespace, import/default, import/no-named-as-default, import/no-named-as-default-member
/* eslint-enabled */

const Layout = ({ t, body }) => (
  <div className="app">
    <header>
      <div className="container site-header">
        <div className="logo">
          <img alt="Cygate/Telia Logo" src={logo} width="114" height="52.81" />
        </div>
        <h1 className="app-title">{t("LayoutApplicationTitle")}</h1>
        <LoginHeader />
      </div>
      <div className="container">
        <NavMenu />
      </div>
    </header>
    <main>{body}</main>
  </div>
);

Layout.propTypes = {
  body: PropTypes.object.isRequired
};

export default translate("translations")(connect()(Layout));



// WEBPACK FOOTER //
// ./src/layout/Layout.js